import axios from "axios";
import { ElMessage } from "element-plus";
import store from "@/store/index";
export const http = axios.create({
  baseURL: "/web.php",
});

function getHashUrlParam(name) {
  const hashParts = window.location.hash.split("?");
  if (hashParts.length < 2) {
    return null;
  }

  const hashQueries = new URLSearchParams(hashParts[1]);
  return hashQueries.get(name);
}
http.interceptors.request.use((config) => {
  const x_site = getHashUrlParam("x-site");
  if (x_site) {
    config.headers["x-site"] = x_site;
  }

  return config;
});

http.interceptors.response.use(
  (res) => {
    const data = res.data;
    if (data.errno !== 0) {
      ElMessage({
        message: data.message,
        grouping: true,
        type: "error",
        repeatNum: -99,
      });
      if (data.errno === 403) {
        store.commit("SET_SHOW_LOGIN", true);
      }
    }
    return data;
  },
  (e) => {
    ElMessage.error(e);
  }
);
